import React from 'react'

export const ExpertPreference = (props:any) => {
    const {age_group_of_therapist,gender_of_therapist} = props;
    return (
        <div className="col-sm-3 mt-5">
            <h4>Expert Preferences</h4>
            <table className="table table-striped border-0 mt-4">
                <tbody>
                    <tr>
                        <th scope="row">Gender of Therapist:</th>
                        <td>{gender_of_therapist}</td>
                    </tr>
                    <tr>
                        <th scope="row">Age Group of Therapist:</th>
                        <td>{age_group_of_therapist}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}
